export default "/assets/images/mila-sock.webp?25cd98aa2a82e54ea88f694f91a1e530";